import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "./api-error";

/**
 * Retrying a request the server already answered clearly is just a slower way
 * to show the same error, and on a 401 it would race the refresh in
 * ApiClient. Only genuine server-side or network faults are worth a retry.
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) {
    return false;
  }

  if (!(error instanceof ApiError)) {
    return false;
  }

  return error.status === 0 || error.status >= 500;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        // Telemetry and device state age quickly; a minute of staleness is
        // the most this screen should show without asking again.
        staleTime: 30_000,
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
